export const initialValuesBookingSlot = {
	firstName: "",
	lastName: "",
	phone: "",
	additionalInformation: "",
}